import { pluginSettingsVar } from '../apollo/store';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const useCheckAddressSuccessHandler = () => {
    const { autoConfig, linkToProductOverview } = pluginSettingsVar();
    const navigate = useNavigate();

    return useCallback(() => {
        if (autoConfig) {
            navigate('../pruefe-produktkonfiguration', { replace: true });
        } else {
            window.location.replace(linkToProductOverview as string);
        }
    }, [autoConfig, navigate, linkToProductOverview]);
};
